export const appInfo = {
  name: 'cgm-external',
  version: '3.2.0'
};



// WEBPACK FOOTER //
// ./src/environments/version.ts